import { apiWithBody, ModuleFE_BaseApi } from '@nu-art/thunderstorm-frontend/index';
import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
import { ApiDef_EncounterSnapshot, DBDef_EncounterSnapshot, } from '@app/ehr-emulator-shared';
export const dispatch_onEncounterSnapshotChanged = new ThunderDispatcherV3('__onEncounterSnapshotUpdated');
export class ModuleFE_EncounterSnapshot_Class extends ModuleFE_BaseApi {
    _v1;
    constructor() {
        super(DBDef_EncounterSnapshot, dispatch_onEncounterSnapshotChanged);
        this._v1 = {
            getEncounterSnapshotsByFilters: apiWithBody(ApiDef_EncounterSnapshot._v1.getEncounterSnapshotsByFilters),
            createEncounterSnapshot: apiWithBody(ApiDef_EncounterSnapshot._v1.createEncounterSnapshot),
        };
    }
}
export const ModuleFE_EncounterSnapshot = new ModuleFE_EncounterSnapshot_Class();
//# sourceMappingURL=ModuleFE_EncounterSnapshot.js.map